import { render, staticRenderFns } from "./TS07.vue?vue&type=template&id=38df7afa&scoped=true&"
import script from "./TS07.vue?vue&type=script&lang=js&"
export * from "./TS07.vue?vue&type=script&lang=js&"
import style0 from "./TS07.vue?vue&type=style&index=0&id=38df7afa&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38df7afa",
  null
  
)

export default component.exports